import React from "react";

export const ItemDatesHelp = () => {
  return (
    <div>
      <div>
        Item dates help, explain how each date interacts with pantry items: eg. Notify date = prioritize in recipes to
        use after this date Best Before date = product is at peak quality until this date Opened date = product was
        opened on this date
      </div>
    </div>
  );
};

export default ItemDatesHelp;
